export default __webpack_public_path__ + "97c7f10.png";